export default __webpack_public_path__ + "static/media/contact-2.d747d8d3.svg";